const recentlyViewedStorageKey = 'chocosphere:recently-viewed-products';
const recentlyViewedHistoryLimit = 50;

function readRecentlyViewedProducts() {
  try {
    const history = JSON.parse(localStorage.getItem(recentlyViewedStorageKey) || '[]');
    if (!Array.isArray(history) || history.some((handle) => typeof handle !== 'string' || !handle.length)) {
      throw new TypeError('Invalid recently viewed product history');
    }
    return [...new Set(history)].slice(0, recentlyViewedHistoryLimit);
  } catch (error) {
    console.warn('Unable to read recently viewed products:', error);
    return [];
  }
}

const recentlyViewedProductData = document.getElementById('RecentlyViewedProduct');
const recentlyViewedCurrentHandle = recentlyViewedProductData ? JSON.parse(recentlyViewedProductData.textContent) : null;

function recordRecentlyViewedProduct() {
  if (!recentlyViewedCurrentHandle || Shopify.designMode) return;

  const history = readRecentlyViewedProducts().filter((handle) => handle !== recentlyViewedCurrentHandle);
  history.unshift(recentlyViewedCurrentHandle);
  try {
    localStorage.setItem(recentlyViewedStorageKey, JSON.stringify(history.slice(0, recentlyViewedHistoryLimit)));
  } catch (error) {
    console.warn('Unable to save recently viewed products:', error);
  }
}

recordRecentlyViewedProduct();

class RecentlyViewedProducts extends HTMLElement {
  connectedCallback() {
    if (this.initialized) return;
    this.initialized = true;
    if (Shopify.designMode) return;
    this.layoutTemplate = this.querySelector('[data-recently-viewed-layout]');
    this.loadProducts();
  }

  async loadProducts() {
    const handles = readRecentlyViewedProducts().filter((handle) => handle !== recentlyViewedCurrentHandle);
    const limit = Number(this.dataset.limit);
    const cards = [];

    // Keep requests bounded, while allowing removed products to be replaced by older views.
    let index = 0;
    while (index < handles.length && cards.length < limit) {
      const batch = handles.slice(index, index + Math.min(4, limit - cards.length));
      const results = await Promise.all(batch.map((handle) => this.fetchCard(handle)));
      if (!this.isConnected) return;
      cards.push(...results.filter((card) => card !== null));
      index += batch.length;
    }

    if (!cards.length) {
      this.hidden = true;
      return;
    }

    const layout = this.layoutTemplate.content.cloneNode(true);
    const grid = layout.querySelector('.product-grid');
    const slider = layout.querySelector('slider-component');
    const title = layout.querySelector('.collection__title');
    const mobileSlider = this.dataset.swipe === 'true' && cards.length > Number(this.dataset.columnsMobile);
    const desktopSlider = this.dataset.desktopSlider === 'true' && cards.length > Number(this.dataset.columnsDesktop);
    const fullWidth = this.dataset.fullWidth === 'true';

    grid.classList.toggle('slider', mobileSlider || desktopSlider);
    grid.classList.toggle('slider--tablet', mobileSlider);
    grid.classList.toggle('grid--peek', mobileSlider);
    grid.classList.toggle('slider--desktop', desktopSlider);
    slider.classList.toggle('page-width', !mobileSlider);
    slider.classList.toggle('page-width-desktop', !desktopSlider && !fullWidth);
    slider.classList.toggle('slider-component-desktop', desktopSlider);
    title.classList.toggle('title-wrapper--self-padded-tablet-down', mobileSlider);
    title.classList.toggle('collection__title--desktop-slider', desktopSlider);

    cards.forEach((card, index) => {
      const item = document.createElement('li');
      item.id = `Slide-${this.dataset.sectionId}-${index + 1}`;
      item.className = 'grid__item';
      item.classList.toggle('slider__slide', mobileSlider || desktopSlider);
      item.append(card);
      grid.append(item);
    });

    const controls = layout.querySelector('.slider-buttons');
    if (mobileSlider || desktopSlider) {
      controls.querySelector('.slider-counter--total').textContent = cards.length;
    } else {
      controls.remove();
    }

    this.hidden = false;
    this.replaceChildren(layout);
  }

  async fetchCard(handle) {
    const url = new URL(`${Shopify.routes.root}products/${encodeURIComponent(handle)}`, window.location.origin);
    url.searchParams.set('section_id', this.dataset.sectionId);

    try {
      const response = await fetch(url);
      if (!response.ok) throw new Error(`Product ${handle}: HTTP ${response.status}`);
      const html = new DOMParser().parseFromString(await response.text(), 'text/html');
      const template = html.querySelector('[data-recently-viewed-card]');
      if (!template || template.dataset.productHandle !== handle) {
        throw new Error(`Missing recently viewed card for ${handle}`);
      }
      return template.content.cloneNode(true);
    } catch (error) {
      console.warn('Unable to load a recently viewed product:', error);
      return null;
    }
  }
}

customElements.define('recently-viewed-products', RecentlyViewedProducts);

window.addEventListener('pageshow', (event) => {
  if (!event.persisted || Shopify.designMode) return;
  recordRecentlyViewedProduct();
  document.querySelectorAll('recently-viewed-products').forEach((section) => section.loadProducts());
});
